module.exports = __webpack_public_path__ + "media/images/stat__background-ce77c6ca0cd9a18ad3674428f6adca9a.jpg";